<ion-card>
    <ion-card-header color="clickker-purple">
        <div class="header-content">
            <ion-card-title>{{ "components.logBookErrorList.title" | translate }}</ion-card-title>

            <div class="header-buttons">
                <ion-button color="light" fill="clear" title="{{'components.logBookErrorList.headerButtons.solveAllErrors' | translate}}" id="resolve-all-errors">
                    <ion-icon name="checkmark-done-circle-outline"></ion-icon>
                </ion-button>
                <ion-button color="light" fill="clear" title="{{'components.logBookErrorList.headerButtons.filter' | translate}}" id="select-error-filters">
                    <ion-icon name="options-outline"></ion-icon>
                </ion-button>
            </div>
        </div>
    </ion-card-header>
    <ion-card-content class="logListContent">
        <div class="errorListContainer">
            @if (isLoading) {
                <div class="loadingShade">
                    <ion-spinner color="primary"></ion-spinner>
                </div>
            }

            <div class="tableContainer">
                <mat-table multiTemplateDataRows [dataSource]="errorsPagedResult.items" >
                    <ng-container matColumnDef="errorType">
                        <mat-header-cell *matHeaderCellDef>{{ "components.logBookErrorList.columns.type" | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let errorDetailPreview">{{ getErrorType(errorDetailPreview) }}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="priority">
                        <mat-header-cell *matHeaderCellDef>{{ "components.logBookErrorList.columns.priority" | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let errorDetailPreview">

                            <ion-chip class="priorityChip" color="{{errorDetailPreview.priority == 'error' ? 'danger' : (errorDetailPreview.priority == 'information' ? 'primary' : 'warning') }}">
                                {{getErrorPriorityDescription(errorDetailPreview.priority)}}
                            </ion-chip>

                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="errorContent">
                        <mat-header-cell *matHeaderCellDef>{{ "components.logBookErrorList.columns.errorContent" | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let errorDetailPreview">{{errorDetailPreview.getSummarizedContent(lengthErrorContent)}}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="firstOccurred">
                        <mat-header-cell *matHeaderCellDef>{{ "components.logBookErrorList.columns.firstOccurred" | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let errorDetailPreview">
                            <ion-icon name="time-outline" class="timeOutlineIcon"></ion-icon>
                            {{errorDetailPreview.firstOccurredAsString}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="mostRecentOccurred">
                        <mat-header-cell *matHeaderCellDef>{{ "components.logBookErrorList.columns.lastOccurred" | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let errorDetailPreview">
                            <ion-icon name="time-outline" class="timeOutlineIcon"></ion-icon>
                            {{errorDetailPreview.lastOccurredAsString}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="isSolved">
                        <mat-header-cell *matHeaderCellDef>{{ "components.logBookErrorList.columns.solveStatus" | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let errorDetailPreview">
                            <div class="solveStatusContainer">
                                @if (!errorDetailPreview.isSolved) {
                                    <p id="unsolvedError">
                                        <ion-icon size="small" name="alert-circle-outline" color="warning"></ion-icon>
                                        {{ "components.errorDetails.errorCardDetails.unsolvedText" | translate }}
                                    </p>
                                } @else {
                                    <p id="solvedError">
                                        <ion-icon size="small" name="checkmark-circle-outline" color="success"></ion-icon>
                                        {{ "components.errorDetails.errorCardDetails.solvedText" | translate }}
                                    </p>
                                }
                            </div>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="expand">
                        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                        <mat-cell *matCellDef="let errorDetailPreview">
                            <ion-button fill="clear" shape="round" class="toggleButton" [class.toggleButtonExpanded]="isExpanded(errorDetailPreview)" (click)="toggle(errorDetailPreview); $event.stopPropagation()">
                                <ion-icon name="chevron-down-outline" slot="icon-only"></ion-icon>
                            </ion-button>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="expandedDetail">
                        <mat-cell class="elementDetailCell"  *matCellDef="let errorDetail">
                                <div class="elementDetailWrapper" [class.elementDetailWrapperExpanded]="isExpanded(errorDetail)" >

                                    @if (isExpanded(errorDetail)) {
                                        <ng-container
                                            *ngComponentOutlet="getDetailsRecordComponent(errorDetail); inputs: createInputs(errorDetail)">
                                        </ng-container>
                                    }

                                </div>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
                    <mat-row class="clickableRow" mat-ripple *matRowDef="let errorDetailPreview; columns: columnsToDisplay;" [class.expandedRow]="isExpanded(errorDetailPreview)"
                            (click)="toggle(errorDetailPreview)"></mat-row>
                    <mat-row [@detailExpand]="isExpanded(row) ? 'expanded' : 'collapsed'" *matRowDef="let row; columns: ['expandedDetail']" class="detailRow"></mat-row>

                    <tr *matNoDataRow class="mat-mdc-row noDataRow">
                        <td class="noDataCell" [attr.colspan]="columnsToDisplay.length">
                            {{ "components.logBookErrorList.noErrorsWithFilterMessage" | translate }}
                        </td>
                    </tr>
                </mat-table>
            </div>  
            <mat-paginator
                class="errorListPagination"
                (page)="changePage($event)"
                [length]="totalAmountOfErrorItems"
                [pageSize]="pageSize"
                [showFirstLastButtons]="true"
                [hidePageSize]="false"
                [disabled]="paginationDisabled"
                [pageSizeOptions]="pageSizeOptions"
                [pageIndex]="currentPageIndex">
            </mat-paginator>
        </div>
    </ion-card-content>
</ion-card>


<ion-modal id="filterModal" trigger="select-error-filters" #filterModal>
    <ng-template>
        <ion-header color="Primary">
            <ion-toolbar color="whitesmoke">
                <ion-buttons slot="start">
                    <ion-button (click)="closeFilterModal()">
                        <ion-icon name="close-circle-outline"></ion-icon>
                    </ion-button>
                </ion-buttons>
                <ion-title>{{"components.logBookErrorList.filter.title" | translate}}</ion-title>
                <ion-buttons slot="end">
                    <ion-button (click)="filter()">
                        <ion-icon name="checkmark-circle-outline"></ion-icon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>

        <ion-content class="ion-padding" color="light">
            <form [formGroup]="filterForm">
                <ion-searchbar placeholder="{{'components.logBookErrorList.filter.inputFields.search' | translate}}" formControlName="search" ></ion-searchbar>
            </form>
        </ion-content>

    </ng-template>
</ion-modal>

<app-confirmation-dialog
  trigger="resolve-all-errors"
  header="components.logBookErrorList.resolveAllErrorsAlert.title"
  message="components.logBookErrorList.resolveAllErrorsAlert.message"
  confirmTextKey="components.logBookErrorList.resolveAllErrorsAlert.buttons.confirm"
  cancelTextKey="components.logBookErrorList.resolveAllErrorsAlert.buttons.cancel"
  (confirmed)="solveAllErrors()"
></app-confirmation-dialog>